import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function IdsChangeConfirmDialog({ids, open, handleClose, handleIDsave, handleBack}) {
  const { t } = useTranslation();
  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="400px"
      >
        <DialogTitle id="alert-dialog-title">
          {t("views.productsManager.confirmIds")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("views.productsManager.ableToAddNewPrice")}
          </DialogContentText>
          <Table sx={{
            mt: 3
          }}>
            <TableHead>
                <TableRow>
                    <TableCell>{t("views.productsManager.old")} ID</TableCell>
                    <TableCell>{t("views.productsManager.new")} ID</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {ids?.map(id => {
                    return (
                        <TableRow>
                            <TableCell>{id.old ? id.old : '-'}</TableCell>
                            <TableCell>{id.new}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBack}>{t("views.productsManager.back")}</Button>
          <Button onClick={handleClose} color="error">{t("views.productsManager.cancel")}</Button>
          <Button onClick={handleIDsave} autoFocus color="success">
            {t("views.productsManager.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
  );
}